import { Pipe } from '@angular/core';
import { extractDeepPropertyByMapKey } from '../helpers/helpers';
var PluckPipe = (function () {
    function PluckPipe() {
    }
    PluckPipe.prototype.transform = function (input, map) {
        return Array.isArray(input)
            ? input.map(function (e) { return extractDeepPropertyByMapKey(e, map); })
            : input;
    };
    PluckPipe.decorators = [
        { type: Pipe, args: [{ name: 'pluck', pure: false },] },
    ];
    /** @nocollapse */
    PluckPipe.ctorParameters = function () { return []; };
    return PluckPipe;
}());
export { PluckPipe };
//# sourceMappingURL=pluck.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/pluck.js
// module id = 229
// module chunks = 4